import { Injectable } from "@angular/core";

import { MatDialog, MatDialogConfig } from "@angular/material/dialog";

import { IInfoTableRow } from "@tylertech/tyler-api-types";
import { EditDialogComponent, EditDialogData, InfoTableDialogComponent, InfoTableDialogData } from "../components";

@Injectable()
export class InfoTableDialogService
{
    constructor(private readonly matDialog: MatDialog) { }

    show(dialogData: InfoTableDialogData): Promise<Array<IInfoTableRow>>
    {
        const dialogConfig: MatDialogConfig<InfoTableDialogData> = {
            data: dialogData,
            minWidth: "50vw",
            minHeight: "590px",
            maxHeight: "80vh"
        };
        const dialogRef = this.matDialog.open<InfoTableDialogComponent, InfoTableDialogData, Array<IInfoTableRow>>(
            InfoTableDialogComponent, dialogConfig);
        return dialogRef.afterClosed()
            .toPromise();
    }

    showEdit(dialogData: EditDialogData): Promise<boolean>
    {
        const dialogConfig: MatDialogConfig<EditDialogData> = {
            data: dialogData,
            minWidth: "50vw",
            maxHeight: "80vh"
        };
        const dialogRef = this.matDialog.open<EditDialogComponent, EditDialogData, boolean>(
            EditDialogComponent, dialogConfig);
        return dialogRef.afterClosed()
            .toPromise();
    }
}
